import { gql } from "@apollo/client";

export default gql`
  mutation exportPerformanceAssessmentCsv(
    $complianceProgramId: Int!
    $userIds: [Int]
    $reportToIds: [Int]
    $teamIds: [Int]
    $roleIds: [Int]
    $roleLevels: [Int]
    $careerTrackIds: [Int]
    $enrollmentDateFilter: [Date]
    $answerFilters: [PerformanceAssessmentAnswerFilter]
    $talentIndicatorFilters: [[PerformanceAssessmentAnswerFilter]]
    $matchAny: Boolean
  ) {
    exportComplianceProgramPerformanceAssessmentToCsv(
      complianceProgramId: $complianceProgramId
      userIds: $userIds
      reportToIds: $reportToIds
      teamIds: $teamIds
      roleIds: $roleIds
      roleLevels: $roleLevels
      enrollmentDateFilter: $enrollmentDateFilter
      careerTrackIds: $careerTrackIds
      answerFilters: $answerFilters
      talentIndicatorFilters: $talentIndicatorFilters
      matchAny: $matchAny
    ) {
      complianceProgram {
        id
      }
    }
  }
`;
